import { useQuery } from '@apollo/client';
import { getYears } from '@nile/banyan/src/Constants/datetime';
import { GET_HOLIDAY_LIST } from '@nile/banyan/src/Graphql/Mutations/holiday';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import {
  AccessControl,
  DeleteModal,
  getTranslatedText,
  Loader
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import NestedEmptyState from '@nile/components/src/Pebbles/NestedEmptyState';
import { AccountClient } from '@nile/graphql';
import {
  Button,
  ButtonGroup,
  Card,
  Heading,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import * as _ from 'lodash';
import React from 'react';
import { injectIntl } from 'react-intl';
import YearSelector from '../../Pebbles/yearSelector';

class HolidayCascade extends React.Component {
  constructor(props) {
    super(props);
    let years = getYears();
    this.state = {
      inputValue: '',
      holidayListName: '',
      year: 1990,
      value: [],
      yearsList: years,
      holidayYear: years[0].name,
      selectedHoliday: props.holidayList.length > 0 ? props.holidayList[0] : [],
      uioptions: [],
      selectedItems:
        props.holidayList.length > 0 ? [props.holidayList[0].id] : [],
      filterExpression: ''
    };
  }

  handleChange = (field) => {
    return (value) => this.setState({ [field]: value });
  };

  componentDidMount() {
    if (this.state.uioptions.length > 0) {
      this.renderSubItem(this.state.uioptions[0]);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.holidayList, this.props.holidayList)) {
      this.setState({ selectedHoliday: nextProps.holidayList[0] });
      this.setState({ selectedItems: [nextProps.holidayList[0].id] });
    }
  }

  renderSubItem(item) {
    this.setState({
      selectedHoliday: {
        id: item.id,
        name: item.name
      },
      selectedItems: [item.id]
    });
  }

  addHolidayList() {
    const { holidayListName } = this.state;
    this.props.addHolidayList({
      variables: { holidayListName },
      input: {
        holidayListName: holidayListName
      }
    });
  }

  deleteHolidayList = (listId) => {
    this.props.deleteHolidayList({
      variables: { listId }
    });
  };

  changeHolidayYear = (value) => {
    this.setState({ holidayYear: value.name });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
      let item = this.props.holidayList.find(
        (el) => el.id === selectedItem[selectedItem.length - 1]
      );
      this.renderSubItem(item);
    }
  };

  debouncedFilter = (value) => {
    this.setState({
      filterExpression: value.toLowerCase(),
      selectedItems: [],
      selectedHoliday: {}
    });
  };

  filterSearchResults = (holidayList) => {
    const { filterExpression } = this.state;
    if (filterExpression) {
      return holidayList.filter(
        (el) => el.name.toLowerCase().indexOf(filterExpression) > -1
      );
    }
    return holidayList;
  };

  handleHolidayListChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const {
      selectedHoliday,
      yearsList,
      selectedItems,
      holidayYear
    } = this.state;
    const { intl, holidayList } = this.props;

    const allItems = this.filterSearchResults(holidayList);

    const processedAllItems = processData(holidayList, 'id');
    return (
      <div className="full-height">
        <div className="fx full-width ch-20">
          <div className="no-scroll white-transparent-bg w30 border-right p20 fh">
            <div className="full-width fh holiday-list-wrap">
              <div className="position-sticky sticky-search">
                <AutoComplete
                  options={processedAllItems}
                  handleChange={this.handleHolidayListChange}
                />
              </div>
              <div className="ch-50 scroll">
                <ResourceList
                  resourceName={{ singular: 'customer', plural: 'customers' }}
                  items={allItems}
                  selectedItems={selectedItems}
                  onSelectionChange={this.setSelectedItems}
                  renderItem={(item, idx) => {
                    const { id, name } = item;
                    return (
                      <div className="list-no-pad">
                        <ResourceItem
                          id={id}
                          accessibilityLabel={`View details for ${name}`}
                        >
                          <div className="fw ellipsis">
                            <TextStyle variation="strong">{name}</TextStyle>
                          </div>
                        </ResourceItem>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
          {selectedHoliday && (
            <div className="fx col scroll w70 white-transparent-bg p2040">
              <div className="full-width">
                <HolidayView
                  holiday={selectedHoliday}
                  changeHolidayYear={this.changeHolidayYear}
                  yearsList={yearsList}
                  year={this.state.holidayYear}
                  listId={selectedHoliday.id}
                  deleteHolidayList={this.deleteHolidayList}
                  filterExpression={this.state.filterExpression}
                  intl={intl}
                  holidayYear={holidayYear}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function HolidayView({
  intl,
  holiday,
  yearsList,
  changeHolidayYear,
  year,
  listId,
  deleteHolidayList,
  filterExpression,
  holidayYear
}) {
  const { loading, error, data: holidaysObj } = useQuery(GET_HOLIDAY_LIST, {
    variables: {
      year,
      id: listId
    },
    client: AccountClient
  });

  let holidays = holidaysObj?.getHolidayList?.holidays;

  const monthKeys = {
    JANUARY: 'report.chart.groupBy.unit.january',
    FEBRUARY: 'report.chart.groupBy.unit.february',
    MARCH: 'report.chart.groupBy.unit.march',
    APRIL: 'report.chart.groupBy.unit.april',
    MAY: 'report.chart.groupBy.unit.may',
    JUNE: 'report.chart.groupBy.unit.june',
    JULY: 'report.chart.groupBy.unit.july',
    AUGUST: 'report.chart.groupBy.unit.august',
    SEPTEMBER: 'report.chart.groupBy.unit.september',
    OCTOBER: 'report.chart.groupBy.unit.october',
    NOVEMBER: 'report.chart.groupBy.unit.november',
    DECEMBER: 'report.chart.groupBy.unit.december'
  };

  return (
    <>
      <div className="ml-10 pd-y20 flex">
        <div className="fx2">
          <div className="fx ">
            <div className="flex-item-balloon">
              <Heading element="h2">{holiday.name}</Heading>
            </div>
            <div className="fx jend actr">
              <ButtonGroup>
                <AccessControl
                  roleToCheck="holidayList.delete"
                  render={
                    <DeleteModal
                      id="deleteHolidayList"
                      description={getTranslatedText(
                        intl,
                        'admin.Holidaymanagement.delete.confirmation'
                      )}
                      handleDeleteConfirmation={() => deleteHolidayList(listId)}
                      title={getTranslatedText(
                        intl,
                        'admin.Holdiaymanagement.list.delete'
                      )}
                    />
                  }
                />
                <AccessControl
                  roleToCheck="holidayList.edit"
                  render={
                    <Button
                      id="editHolidayList"
                      // size="slim"
                      icon={<SVGIcon name="Edit" />}
                      url={
                        '#/onboard/holidays/' +
                        holidaysObj?.getHolidayList?.id +
                        '/edit/' +
                        year
                      }
                      data-qa="edit-holiday-list"
                    />
                  }
                />
              </ButtonGroup>
            </div>
          </div>

          <div className="pt-25" data-qa="holiday-mgmt-year-select">
            <YearSelector
              yearsList={yearsList}
              onSelect={changeHolidayYear}
              selected={holidayYear}
            />
          </div>
        </div>
      </div>
      <div className="ml20">
        {loading ? (
          <div className="flex actr jctr w100 h-300">
            <Loader />
          </div>
        ) : (
          <>
            {holidays.length > 0 ? (
              <ResourceList
                resourceName={{ singular: 'customer', plural: 'customers' }}
                items={holidays}
                renderItem={(item) => {
                  const { id, name, day, month } = item;
                  return (
                    <div className="List-Bg-White">
                      <ResourceItem
                        id={id}
                        accessibilityLabel={`View details for ${name}`}
                      >
                        <div className="sops-display-block">
                          <div className="fx actr">
                            <div className="min-width-110 text-uppercase">
                              {getTranslatedText(intl, monthKeys[month])}
                            </div>
                            <div className="min-w80">{day}</div>
                            <div className="min-w80">{name}</div>
                          </div>
                        </div>
                      </ResourceItem>
                    </div>
                  );
                }}
              />
            ) : (
              <NestedEmptyState message="no holidays found" />
            )}
          </>
        )}
      </div>
    </>
  );
}

export default injectIntl(HolidayCascade);
